import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['ManageTripBoard'],
});

export const manageTripBoardApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findManageTripBoardTrailerUsageSummary: builder.query({
      query: (id) => `manage_trip/trailer_usage_summary/`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'ManageTripBoard', id: result.id }]
          : ['ManageTripBoard'];
      },
    }),
    findManageTripBoardCheck: builder.mutation({
      query: (id) => `manageTripBoard/summary_all_unit_id?=${id}`,
      keepUnusedDataFor: 0,
      providesTags: ['ManageTripBoard'],
    }),

    findAllManageTripBoardSummaryTrip: builder.mutation({
      query: (params) =>
        `manage_trip/summary/?working_date=${params.working_date}&location_from_id=${params.location_from_id}&plan_job_id=${params.plan_job_id}`,
      keepUnusedDataFor: 0,
      providesTags: ['ManageTripBoard'],
    }),
    findManageTripBoardByFrom: builder.mutation({
      query: (params) => `manageTripBoard/search_from?=${params.location_from}`,
      keepUnusedDataFor: 0,
      providesTags: ['ManageTripBoard'],
    }),
    findManageTripBoardClusterByRegion: builder.mutation({
      query: (id) => `manageTripBoard/cluster_by_region?=${id}`,
      keepUnusedDataFor: 0,
      providesTags: ['ManageTripBoard'],
    }),
    findManageTripBoardBySubCluster: builder.mutation({
      query: (id) => `manageTripBoard/sub_cluster?=${id}`,
      keepUnusedDataFor: 0,
      providesTags: ['ManageTripBoard'],
    }),
    setDiagramPeriodManageTripBoard: builder.mutation({
      query: (payload) => ({
        url: `diagram_period/`,
        method: 'POST',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['ManageTripBoard'],
    }),
    searchDataYardManageTripBoard: builder.mutation({
      query: (payload) =>
        `manageTripBoard/display_summary_volume/?period_from=${payload.period_from}&period_to=${payload.period_to}&location_from=${payload.location_from}`,
      keepUnusedDataFor: 0,
      providesTags: ['ManageTripBoard'],
    }),
    uploadFileManageTripBoard: builder.mutation({
      query: (payload) => ({
        url: `manageTripBoard/create_or_update_file/`,
        method: 'POST',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['ManageTripBoard'],
    }),
    findFilterDataManageTripBoard: builder.mutation({
      query: (payload) =>
        `manageTripBoard/filter_data/?period_from=${payload.period_from}&period_to=${payload.period_to}&location_from=${payload.location_from}`,
      keepUnusedDataFor: 0,
      providesTags: ['ManageTripBoard'],
    }),
    findFilterSearchManageTripBoard: builder.mutation({
      query: (payload) =>
        `manageTripBoard/display_detail_volume/?volume_date=${payload.volume_date}&vehicle_type=${payload.vehicle_type}&location_from=${payload.location_from}&location_to=${payload.location_to}&region=${payload.region}&limit=${payload.limit}&offset=${payload.offset}`,
      keepUnusedDataFor: 0,
      providesTags: ['ManageTripBoard'],
    }),
    editVolumeManageTripBoard: builder.mutation({
      query: (payload) => ({
        url: `manageTripBoard/edit_volume/`,
        method: 'PATCH',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['ManageTripBoard'],
    }),
    clearDataVolumeManageTripBoard: builder.mutation({
      query: (payload) => ({
        url: `manageTripBoard/clear_data/`,
        method: 'DELETE',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['ManageTripBoard'],
    }),
    confirmDataVolumeManageTripBoard: builder.mutation({
      query: (payload) => ({
        url: `manageTripBoard/confirm_data/`,
        method: 'POST',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['ManageTripBoard'],
    }),
    // findDetailGraph: builder.mutation({
    //   query: (payload) =>
    //     `manage_trip/detail/graph/?working_date=${payload.working_date}&location_from_id=${payload.location_from_id}&plan_job_id=${payload.plan_job_id}&time=11:00&mode=${payload.mode}&region_name=${payload.region_name}`,
    //   keepUnusedDataFor: 0,
    //   providesTags: ['ManageTripBoard'],
    // }),

    findManageTripDetailGraph: builder.query({
      query: (payload) => {
        let url = `manage_trip/detail/graph/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);

        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      // providesTags: ['StatusSummary'],
    }),
    findManageTripDetail: builder.query({
      query: (payload) => {
        let url = `manage_trip/detail/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);

        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      // providesTags: ['StatusSummary'],
    }),
 
    updateManageTripDetail: builder.mutation({
      query: (payload) => ({
        url: `manage_trip/diagram_lot/${payload.id}/`,
        method: 'PUT',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['ManageTripBoard'],
    }),
     //confirm manage trip board
     confirmManageTripBoard: builder.mutation({
      query: (payload) => ({
        url: `manage_trip/confirm/plan_job/${payload.plan_job_id}/`,
        method: 'PUT',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['ManageTripBoard'],
    }),

  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindManageTripBoardCheckMutation,
  useFindManageTripBoardByFromMutation,
  useFindManageTripBoardClusterByRegionMutation,
  useFindManageTripBoardBySubClusterMutation,
  // useFindEntryManageTripBoardMutation,
  useFindManageTripBoardTrailerUsageSummaryQuery,
  useSetDiagramPeriodManageTripBoardMutation,
  useSearchDataYardManageTripBoardMutation,
  useUploadFileManageTripBoardMutation,
  useFindFilterDataManageTripBoardMutation,
  useFindFilterSearchManageTripBoardMutation,
  useEditVolumeManageTripBoardMutation,
  useClearDataVolumeManageTripBoardMutation,
  useConfirmDataVolumeManageTripBoardMutation,
  useUpdateManageTripDetailMutation,
  useConfirmManageTripBoardMutation,
} = manageTripBoardApi;
